import { Loader2 } from 'lucide-react';

/**
 * Componente de loading reutilizable
 */
const Loading = ({ message = 'Cargando...', fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
        <div className="text-center">
          <Loader2 className="w-12 h-12 text-primary-700 animate-spin mx-auto mb-4" />
          <p className="text-gray-600 font-medium">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Loader2 className="w-10 h-10 text-primary-700 animate-spin mb-3" />
      <p className="text-gray-600">{message}</p>
    </div>
  );
};

export default Loading;
